import { convertTimeStampToDate } from '../../../../common/utils/dateUtils';
import {
  FieldTypes,
  hiddenFormField,
  StringFields,
  ImageFields,
  largeTextNumberField,
} from 'drapcode-constant';
import { filterFieldOption } from '../derived-query/query-util';
const excludedFieldName = [...hiddenFormField];
const excludedFieldType = [
  ...StringFields,
  ...ImageFields,
  ...largeTextNumberField,
  FieldTypes.file.id,
  FieldTypes.updatedAt.id,
  FieldTypes.isDeleted.id,
  FieldTypes.belongsTo.id,
  FieldTypes.color.id,
  FieldTypes.reference.id,
  FieldTypes.date.id,
  FieldTypes.video_link.id,
  FieldTypes.boolean.id,
];

export const createSelectOptionsForField = (fields) => {
  return filterFieldOption(fields, excludedFieldType, excludedFieldName);
};

export const convertArrayToString = (arr, key) => {
  if (arr) {
    return arr.map((obj) => obj[key]).join(', ');
  } else {
    return [];
  }
};

const extractValue = (itemValue) => {
  if (Array.isArray(itemValue)) {
    return itemValue.join(',');
  }
  return itemValue;
};

export const addRule = (rules) => {
  const newRuleObj = {
    id: rules.length + 1,
    currentValue: '',
    nextValue: [],
    role: '',
  };
  rules.push(newRuleObj);
  return rules;
};

export const removeRule = (currentConditions, id) => {
  let noOfItem = 1,
    newConditions = [];
  currentConditions.forEach((condition) => {
    if (id !== condition.id) {
      condition.id = noOfItem;
      newConditions.push(condition);
      noOfItem++;
    }
  });
  return newConditions;
};

export const updateRule = (rules, id, ruleObj) => {
  rules.forEach((rule) => {
    if (rule.id === id) {
      rule.role = ruleObj.role;
      rule.currentValue = ruleObj.currentValue;
      rule.nextValue = ruleObj.nextValue;
    }
  });
  return rules;
};

export const saveRuleUtil = (props, state) => {
  const { nextValue } = state;

  if (!nextValue) {
    return { nextValue: 'Please select Next Value', status: 'ERROR' };
  }

  return {
    role: state.role,
    currentValue: state.currentValue,
    nextValue: state.nextValue,
    status: 'SUCCESS',
  };
};

export const showSaveButtonWorkflowUtil = (props, state) => {
  const { keyField, rule } = props;
  const { nextValue } = state;

  if (keyField && nextValue && nextValue.length > 0) {
    if (rule && rule.nextValue && rule.nextValue.length > 0) {
      return false;
    } else {
      return true;
    }
  }
  return false;
};
